/* src/components/pdf-page-tis-quickscan/pdf-page-tis-quickscan.component.scss */
app-pdf-page-tis-quickscan {
  display: block;
}
/*# sourceMappingURL=pdf-page-tis-quickscan.component-TPHOJEDB.css.map */
